import { Store } from './types';
import { setupFetchSiteWhenUserFetched } from './slices/recordingsListSlice/listeners/setupFetchSiteWhenUserFetched';
import { setupFetchListOnRecordingChange } from './slices/recordingsListSlice/listeners/setupFetchListOnRecordingChange';
import { setupSetWatchedRecordingsOnRecordingChange } from './slices/recordingsListSlice/listeners/setupSetWatchedRecordingsOnRecordingChange';

export const setupListeners = (store: Store): void => {
  const { isScreenshotMode, isHighlightMode, isRetakerMode } = store.getState();
  if (isScreenshotMode || isHighlightMode || isRetakerMode) {
    return;
  }

  /**
   * recordingsListSlice side effects
   */
  setupFetchSiteWhenUserFetched(store);
  setupFetchListOnRecordingChange(store);
  setupSetWatchedRecordingsOnRecordingChange(store);
};
